<template>
  <div class="goods-detail-box" v-if="info.id">
    <OperationBoxComponent :actions="actions" />
    <div class="goods-content">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
          <el-button style="float: right; padding: 3px 0" type="text">当前状态：【{{goodsConfig.auditStateMap[info.audit_state]['title']}}】</el-button>
        </div>
        <div class="content">
          <el-row class="row" :gutter="30"><el-col class="title" :span="3">交易类型：</el-col><el-col :span="20">{{goodsConfig.tradeTypeMap[info.trade_type]['title']}}</el-col></el-row>
          <el-row class="row" :gutter="30"><el-col class="title" :span="3">标题：</el-col><el-col :span="20">{{info.title}}</el-col></el-row>
          <el-row class="row" :gutter="30"><el-col class="title" :span="3">物品类型：</el-col><el-col :span="20">{{info.goods_type}}</el-col></el-row>
          <el-row class="row" :gutter="30"><el-col class="title" :span="3">价格：</el-col><el-col :span="20">{{info.price}}</el-col></el-row>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>描述信息</span>
        </div>
        <div class="content">
          <el-row class="row" :gutter="30"><el-col class="title" :span="3">成色：</el-col><el-col :span="20">{{info.quality}}成新</el-col></el-row>
          <el-row class="row" :gutter="30"><el-col class="title" :span="3">描述：</el-col><el-col :span="20"><div class="description">{{info.description}}</div></el-col></el-row>
          <el-row class="row" :gutter="30"><el-col class="title" :span="3">图片：</el-col>
            <el-col :span="20">
              <div class="images">
                <el-image v-for="(item,index) in images" style="max-width: 200px; max-height: 200px" :key="'image'+index" :src="item" :preview-src-list="images"/>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import {GoodsRequestUtil} from '../../../utils/GoodsRequestUtil'
export default {
  name: 'GoodsDetailPage',
  components: { OperationBoxComponent },
  data () {
    return {
      actions: [
        { title: '', icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateGoodsInfo },
        { title: '通过', type: 'button', theme: 'success', action: () => { GoodsRequestUtil.pass({ids: [this.params.id]}, this.updateGoodsInfo) } },
        { title: '拒绝', type: 'button', theme: 'warning', action: () => { GoodsRequestUtil.refuse({ids: [this.params.id]}, this.updateGoodsInfo) } },
        { title: '删除', type: 'button', theme: 'danger', action: () => { GoodsRequestUtil.remove({ids: [this.params.id]}, this.updateGoodsInfo) } }
      ],
      info: {},
      images: [],
      params: {
        id: 0
      }
    }
  },
  mounted () {
    this.params.id = this.$route.params.remark
    this.updateGoodsInfo()
  },
  methods: {
    updateGoodsInfo () {
      let that = this
      GoodsRequestUtil.queryGoodsInfo(this.params, function (response) {
        that.info = response
        that.images = []
        for (let i in response.goods_imgs) {
          that.images.push(response.goods_imgs[i].url)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.box-card{
  font-size: 14px;
  margin-top: 10px;

  .row{
    margin:10px 0;
    .title{
      text-align: right;
    }
  }

  /deep/ .el-image-viewer__close{
    color:#fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/whaledge/goods/GoodsDetailPage.vue